import { API_URL } from './Api';

export const API_URN = '/v1/delegacao-acesso';

export function PESQUISA_PERMISSIONARIOS(idCorreios) {
  return {
    url: `${API_URL}${API_URN}/${idCorreios}`,
    options: {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}
export function PESQUISA_PERMISSIONARIOS_PAGINADO(idCorreios, filtros) {
  const paramsQueryString = new URLSearchParams(filtros).toString();

  return {
    url: `${API_URL}${API_URN}/paginado/${idCorreios}?${paramsQueryString}`,
    options: {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}
export function CARREGA_SISTEMAS_CONTRATOS(idCorreios, idCorreiosPF) {
  return {
    url: `${API_URL}${API_URN}/${idCorreios}/carregaSistemasEContratos/${idCorreiosPF}`,
    options: {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}

export function CARREGA_CARTOES(
  idCorreios,
  idCorreiosPF,
  idCorreiosPFLogado,
  perfil,
) {
  return {
    url: `${API_URL}${API_URN}/listarcartoes/${idCorreios}/${idCorreiosPF}/${idCorreiosPFLogado}/${perfil}`,
    options: {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}

export function CARREGA_GRUPOS(
  idCorreios,
  idCorreiosPF,
  idCorreiosPFLogado,
  perfil,
) {
  return {
    url: `${API_URL}${API_URN}/listargrupos/${idCorreios}/${idCorreiosPF}/${idCorreiosPFLogado}/${perfil}`,
    options: {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}

export function PERMISSIONARIO_EXCLUIR(idCorreios, idCorreiosPF, ipAddress) {
  return {
    url: `${API_URL}${API_URN}/${idCorreios}/${idCorreiosPF}`,
    options: {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'X-Forwarded-For': ipAddress,
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}

export function PERMISSIONARIO_EXCLUIR_LISTA(idCorreios, lista, ipAddress) {
  return {
    url: `${API_URL}${API_URN}/${idCorreios}`,
    options: {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'X-Forwarded-For': ipAddress,
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(lista),
    },
  };
}

export function PESQUISA_LISTA_USUARIOS(idCorreios, lista) {
  return {
    url: `${API_URL}${API_URN}/${idCorreios}/listaUsuarios/${lista}`,
    options: {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}

export function PESQUISAR_CARTOES_CENTROCUSTO_PJ(
  idCorreios,
  cnpjAn8,
  nuContrato,
) {
  return {
    url: `${API_URL}${API_URN}/listarcartoesporcentrocusto/${idCorreios}/${cnpjAn8}/${nuContrato}`,
    options: {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}

export function PESQUISAR_SISTEMAS_GRUPOS(idCorreios) {
  return {
    url: `${API_URL}${API_URN}/sistemagrupo/${idCorreios}`,
    options: {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}

export function PESQUISAR_SISTEMAS_GRUPOS_SUPERVISOR(
  idCorreios,
  idCorreiosSupervisor,
) {
  return {
    url: `${API_URL}${API_URN}/sistemagruposupervisor/${idCorreios}/${idCorreiosSupervisor}`,
    options: {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}

export function PERMISSIONARIO_INCLUIR_CARTOES(idCorreios, body, ipAddress) {
  return {
    url: `${API_URL}${API_URN}/cartoes/${idCorreios}`,
    options: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Forwarded-For': ipAddress,
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(body),
    },
  };
}
export function PERMISSIONARIO_INCLUIR_SISTEMAS(idCorreios, body, ipAddress) {
  return {
    url: `${API_URL}${API_URN}/sistemas/${idCorreios}`,
    options: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Forwarded-For': ipAddress,
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(body),
    },
  };
}
export function PERMISSIONARIO_EDITAR_CARTOES(idCorreios, body, ipAddress) {
  return {
    url: `${API_URL}${API_URN}/cartoes/${idCorreios}`,
    options: {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'X-Forwarded-For': ipAddress,
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(body),
    },
  };
}
export function PERMISSIONARIO_EDITAR_SISTEMAS(idCorreios, body, ipAddress) {
  return {
    url: `${API_URL}${API_URN}/sistemas/${idCorreios}`,
    options: {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'X-Forwarded-For': ipAddress,
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(body),
    },
  };
}

export function PESQUISAR_CONTRATOS_SUPERVISOR(
  idCorreios,
  idCorreiosSupervisor,
) {
  return {
    url: `${API_URL}${API_URN}/contratosupervisor/${idCorreios}/${idCorreiosSupervisor}`,
    options: {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}
